// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:23:19

export default {
  "id": "drive-to-survive",
  "slug": "drive-to-survive",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/9f9037619d1b4024b9b860dfcc3b86be-512x512.jpg",
  "gameUrl": "https://html5.gamedistribution.com/9f9037619d1b4024b9b860dfcc3b86be/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Drive To Survive",
      "description": "Dive into the world of the zombie apocalypse, where your car is the only weapon!\nShoot down hordes of zombies, earn money and unlock new powerful cars.\n\nEarn money - use your skills to become a master of survival!\nBuy cars - from classics to supercars!\nExplore new locations - each level is full of challenges!\n\nShow the zombies who's boss!",
      "instructions": "Objective of the game: Clear the location of zombies using drift in your car.\n\nControls on a mobile device:\n\n- Turn left: Tap on the left side of the screen.\n- Turn right: Tap on the right side of the screen.\n\nCombo: Knock down several zombies in a row to activate a combo and earn more money!\n\nMoney: Earned money can be used to buy new cars in the store. Improve your arsenal and become a drift master in the fight against zombies!",
      "genres": [
        "Casual",
        "Racing & Driving"
      ],
      "tags": [
        "apocalypse",
        "arcade",
        "car",
        "enemies",
        "zombie"
      ]
    },
    "zh-CN": {
      "title": "求生驾驶",
      "description": "深入僵尸末日世界，你的汽车就是唯一的武器！击溃成群的僵尸，赚取金钱并解锁新强力汽车。\n\n赚取金钱 - 运用你的技能成为生存大师！\n购买汽车 - 从经典车型到超级跑车！\n探索新地点 - 每个关卡都充满挑战！\n\n向僵尸展示谁是老大！",
      "instructions": "游戏目标：使用你的汽车漂移清除地点上的僵尸。\n\n移动设备上的控制方式：\n\n- 向左转：轻触屏幕左侧。\n- 向右转：轻触屏幕右侧。\n\n连击：连续击倒多个僵尸以激活连击，并获得更多金钱！\n\n金钱：赚取的金钱可以用于商店购买新车。升级你的装备，成为对抗僵尸的漂移大师！",
      "genres": [
        "休闲",
        "赛车与驾驶"
      ],
      "tags": [
        "末日",
        "街机",
        "汽车",
        "敌人",
        "僵尸"
      ]
    },
    "zh-TW": {
      "title": "駕馭生存",
      "description": "深入末日僵尸的奇幻世界，你的車子就是唯一的武器！射擊成群的僵尸，賺取金錢並解鎖新強力的車輛。\n\n賺取金錢——運用你的技巧成為生存的大師！\n購買車輛——從經典車款到超跑！\n探索新地點——每個關卡都充滿挑戰！\n\n向僵尸展示誰才是老大！",
      "instructions": "遊戲目標：使用你的車進行漂移，清空地點上的僵尸。\n\n移動裝置上的控制：\n\n- 向左轉：點擊螢幕的左側。\n- 向右轉：點擊螢幕的右側。\n\n連擊：連續擊倒多個僵尸以啟動連擊，並獲得更多金錢！\n\n金錢：所獲得的金錢可用於商店購買新車。提升你的武器庫，成為對抗僵尸的漂移大師！",
      "genres": [
        "休闲",
        "賽車與駕駛"
      ],
      "tags": [
        "末日",
        "電玩",
        "車輛",
        "敵人",
        "僵屍"
      ]
    },
    "zh-HK": {
      "title": "馳駛求存",
      "description": "跳入末日僵尸的宇宙，你的車即是唯一的武器！擊敗群魔，賺取金錢，解鎖全新強力車輛。\n\n賺取金錢 - 用你的技巧成為生存大師！\n購買車輛 - 由經典車款到超跑！\n探索新地點 - 每一關都充滿挑戰！\n\n向僵尸展現誰才是老大！",
      "instructions": "遊戲目標：使用你的車漂移清空地點上的僵屍。\n\n移動裝置上的控制方式：\n\n- 向左轉：輕觸螢幕左側。\n- 向右轉：輕觸螢幕右側。\n\n連擊：連續擊倒多個僵屍以啟動連擊並獲得更多錢幣！\n\n錢幣：所獲得的錢幣可用於商店購買新車。提升你的武器庫並成為對抗僵屍的漂移大師！",
      "genres": [
        "隨意",
        "賽車及駕駛"
      ],
      "tags": [
        "世界末日",
        "街機",
        "車輛",
        "敵人",
        "僵屍"
      ]
    },
    "ja": {
      "title": "ドライブ・トゥ・サバイブ",
      "description": "ゾンビ大脱出の世界に飛び込み、車が唯一の武器です！ゾンビの群れを撃ち倒し、お金を稼ぎ、新しい強力な車を解放しましょう。\n\nお金を稼ぐ - 技術を使って生き延びの達人に！\n車を購入する - クラシックからスーパーカーまで！\n新しい場所を探索する - 各レベルは挑戦に満ちています！\n\nゾンビに誰が王者かを見せましょう！",
      "instructions": "ゲームの目的: 自分の車でドリフトを使ってゾンビを全滅させる。\n\nモバイルデバイスの操作:\n\n- 左にターン: スクリーンの左側をタップ。\n- 右にターン: スクリーンの右側をタップ。\n\nコンボ: 複数のゾンビを連続して倒してコンボを発動させ、さらにお金を稼ぐ！\n\nお金: 賢威を稼いだお金は、ストアで新しい車を購入するために使用できます。武器を強化し、ゾンビとの戦いでドリフトマスターになる！",
      "genres": [
        "カジュアル",
        "レーシング＆ドライビング"
      ],
      "tags": [
        "アポカリプス",
        "アーケード",
        "車",
        "敵",
        "ゾンビ"
      ]
    },
    "ko": {
      "title": "드라이브 투 서바이브",
      "description": "좀비 대폭발의 세계로 뛰어들어, 차가 유일한 무기인 곳을 경험해보세요!\n좀비 무리를 쏘아DOWN하고 돈을 벌어 새로운 강력한 차를 해금하세요.\n\n돈을 벌어 - 자신의 기술을 사용하여 생존의 마스터가 되세요!\n차를 구매하세요 - 클래식부터 슈퍼카까지!\n새로운 장소를 탐험하세요 - 각 레벨은 도전으로 가득 차 있습니다!\n\n좀비에게 누가 보스인지 보여주세요!",
      "instructions": "게임 목표: 자동차를 사용하여 드라이브로 죽은 자들의 위치를 clear합니다.\n\n모바일 기기의 조작:\n\n- 왼쪽으로 회전: 화면 왼쪽을 탭합니다.\n- 오른쪽으로 회전: 화면 오른쪽을 탭합니다.\n\n콤보: 연속적으로 여러 명의 죽은 자를 쓰러뜨려 콤보를 활성화하고 더 많은 돈을 법니다!\n\n돈: 벌은 돈은 가게에서 새로운 차를 구매할 수 있습니다. 무기를 개선하고 죽은 자와의 전투에서 드라이브 마스터가 되세요!",
      "genres": [
        "캐주얼",
        "레이싱 & 드라이빙"
      ],
      "tags": [
        "최후의 날",
        "아케이드",
        "자동차",
        "적",
        "좀비"
      ]
    },
    "fr": {
      "title": "Conduis pour survivre",
      "description": "Plongez dans le monde de l'apocalypse zombie, où votre voiture est l'unique arme !\nTirez sur les hordes de zombies, gagnez de l'argent et débloquez de nouvelles voitures puissantes.\n\nGagnez de l'argent - utilisez vos compétences pour devenir un maître de la survie !\nAchetez des voitures - des classiques aux supercars !\nExplorez de nouveaux lieux - chaque niveau est rempli de défis !\n\nMontrez aux zombies qui est le patron !",
      "instructions": "Objectif du jeu : Évacuer le lieu des zombies en utilisant des drifts avec votre voiture.\n\nContrôles sur un appareil mobile :\n\n- Tourner à gauche : Taper sur le côté gauche de l'écran.\n- Tourner à droite : Taper sur le côté droit de l'écran.\n\nCombinaison : Abattez plusieurs zombies d'affilée pour activer une combinaison et gagner plus d'argent !\n\nArgent : L'argent gagné peut être utilisé pour acheter de nouvelles voitures dans le magasin. Améliorez votre arsenal et devenez un maître du drift dans la lutte contre les zombies !",
      "genres": [
        "Occasionnel",
        "Courses & Conduite"
      ],
      "tags": [
        "apocalypse",
        "arcade",
        "voiture",
        "ennemis",
        "zombie"
      ]
    }
  }
};
